import React, { useEffect, useState } from 'react';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import { useDispatch, useSelector } from 'react-redux';
import { createConfig, getConfiguration } from '../../../redux/features/taskManagementSlice';
import { DataGrid } from '@mui/x-data-grid';
import CustomGridToolbar from '../../../components/datagrid/GridToolBar';
import { Alert, Box } from '@mui/material';
import { taskConfigColumns } from './ConfigTableHead';
import CreateConfig from './CreateConfig';
import useHandleApiResponse from '../../../Hooks/useHandleApiResponse';

const ConfigView = () => {
  const dispatch = useDispatch();
  const { configuration, loading } = useSelector((state) => state.taskManagement);
  const [gridSize, setGridSize] = useState(10);
  const profile = JSON.parse(localStorage.getItem('cred')).profile;
  const handleApiResponse = useHandleApiResponse();

  useEffect(() => {
    dispatch(getConfiguration(profile.departmentId));
  }, [dispatch, profile.departmentId]);

  const handleProcessRowUpdate = async (newRow, oldRow) => {
    try {
      // PM Approval update
      if (newRow.pm_approval_needed !== oldRow.pm_approval_needed) {
        const res = await dispatch(
          createConfig({
            department_id: profile.departmentId,
            type: oldRow.type,
            pm_approval_needed: newRow.pm_approval_needed,
          }),
        );

        let isSuccess = false;

        handleApiResponse(res, {
          onSuccess: () => (isSuccess = true),
          onFailed: () => (isSuccess = false),
        });

        if (!isSuccess) return oldRow;
      }

      // Delta Approval update
      if (newRow.delta_approval_needed !== oldRow.delta_approval_needed) {
        const res = await dispatch(
          createConfig({
            department_id: profile.departmentId,
            type: oldRow.type,
            delta_approval_needed: newRow.delta_approval_needed,
          }),
        );

        let isSuccess = false;

        handleApiResponse(res, {
          onSuccess: () => (isSuccess = true),
          onFailed: () => (isSuccess = false),
        });

        if (!isSuccess) return oldRow;
      }

      return newRow;
    } catch (error) {
      console.error(error);
      return oldRow;
    }
  };

  return (
    <GlobalWrapper title={'Task Configurations'} actions={<CreateConfig />}>
      <Alert severity="info" sx={{ mb: 2 }}>
        Double click on <b>PM Approval</b> or <b>Delta Approval</b> to update status.
      </Alert>
      <Box>
        <DataGrid
          components={{ Toolbar: CustomGridToolbar }}
          rows={configuration}
          columns={taskConfigColumns}
          loading={loading}
          getRowId={(row) => row.serialNumber}
          pageSize={gridSize}
          autoHeight
          rowsPerPageOptions={[5, 10, 25, 50]}
          onPageSizeChange={(newSize) => setGridSize(newSize)}
          processRowUpdate={handleProcessRowUpdate}
          experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default ConfigView;
